export var Color = {
  TextPrimary: 'txt-primary',
  TextSecondary: 'txt-secondary',
  TextSecondaryInvert: 'txt-secondary-invert',
  TextPlaceholder: 'txt-placeholder',
  TextWarning: 'txt-warning',
  TextError: 'txt-error',
  TextInfo: 'txt-info',
  AccentPrimary: 'accent-primary',
  AccentPrimaryHover: 'accent-primary-hover',
  AccentPrimaryActive: 'accent-primary-active',
  AccentPrimaryDisabled: 'accent-primary-disabled',
  AccentSecondaryDisabled: 'accent-secondary-disabled',
  AccentStateless: 'accent-stateless',
  AccentStateless_0_4_Opacity: 'accent-stateless_0_4_opacity',
  Accent_0_5_Opacity: 'accent_0_5_opacity',
  Accent_1_2_Opacity: 'accent_1_2_opacity',
  Accent_1_8_Opacity: 'accent_1_8_opacity',
  Accent_2_8_Opacity: 'accent_2_8_opacity',
  Accent_4_0_Opacity: 'accent_4_0_opacity',
  BackgroundGrey: 'bg-grey',
  BackgroundStateless: 'bg-stateless',
  BackgroundActive: 'bg-active',
  BackgroundBaseLight: 'bg-base-light',
  BackgroundBaseMedium: 'bg-base-medium',
  BackgroundPrimary: 'bg-primary',
  BackgroundPrimaryLight: 'bg-primary-light',
  BackgroundPrimaryHover: 'bg-primary-hover',
  BackgroundPrimaryActive: 'bg-primary-active',
  BackgroundPrimaryStateless: 'bg-primary-stateless',
  BackgroundPrimary_0_5_Opacity: 'bg-primary-0-5-opacity',
  BackgroundSecondary: 'bg-secondary',
  BackgroundHover: 'bg-hover',
  BackgroundGreen: 'bg-green',
  BackgroundGreenMedium: 'bg-green-medium',
  BackgroundBlue: 'bg-blue',
  BackgroundRed: 'bg-red',
  BackgroundRedLight: 'bg-red-light',
  BackgroundRedMedium: 'background-red-medium',
  BackgroundOrange: 'bg-orange',
  BackgroundTooltip: 'bg-tooltip',
  IconsPrimary: 'icon-primary',
  IconsPrimaryOpacity_0_6: 'icons-primary-opacity-0-6',
  IconsSecondary: 'icons-secondary',
  IconsPlaceholder: 'icons-placeholder',
  IconsInvert: 'icons-invert',
  IconsMuted: 'icons-muted',
  IconsPrimaryHover: 'icons-primary-hover',
  IconsSecondaryHover: 'icons-secondary-hover',
  ButtonPrimaryText: 'btn-primary-text',
  ButtonPrimaryText_0_6: 'btn-primary-text-0-6',
  ButtonPrimaryText_0_4: 'btn-primary-text-0-4',
  ButtonDisabledText: 'btn-disabled-text',
  ButtonSecondaryText: 'btn-secondary-text',
  LinkPrimary: 'link-primary',
  LinkStateless: 'link-stateless',
  LinkHover: 'link-hover',
  LinkActive: 'link-active',
  LinkMuted: 'link-muted',
  LinkPressed: 'link-pressed',
  BordersPrimary: 'borders-primary',
  BordersPrimaryHover: 'borders-primary-hover',
  BordersSecondary: 'borders-secondary',
  BordersStrong: 'borders-strong',
  BordersInvert: 'borders-invert',
  BorderHoverBottom: 'border-hover-bottom',
  BorderActiveBottom: 'border-active-bottom',
  BorderPrimaryStateless: 'border-primary-stateless',
  BordersDisabled: 'borders-disabled',
  BordersButton: 'borders-button',
  BordersItem: 'borders-item',
  BordersBaseLight: 'borders-base-light',
  BordersBaseMedium: 'borders-base-medium',
  BordersGreen: 'borders-green',
  BordersGreenMedium: 'borders-green-medium',
  BordersRed: 'borders-red',
  ActiveSecondary: 'active-secondary',
  ActiveSecondaryHover: 'active-secondary-hover',
  Tag: 'tag',
  StatesErrorDisabledText: 'states-error-disabled-text',
  Error: 'error',
  Error_0_28_Opacity: 'error-0-28-opacity',
  Error_0_12_Opacity: 'error-0-12-opacity',
  ErrorHover: 'error-hover',
  ErrorActive: 'error-active',
  Success: 'success',
  SuccessHover: 'success-hover',
  SuccessActive: 'success-Active',
  Warning: 'warning',
  WarningHover: 'warning-hover',
  WarningActive: 'warning-active',
  Info: 'info',
  Modified: 'modified',
  Red: 'red',
  Orange: 'orange',
  Salad: 'salad',
  Green: 'green',
  Blue: 'blue',
  Indigo: 'indigo',
  Violet: 'violet',
  Pink: 'pink',
  GradientRight: 'gradient-right',
  Extra_0_3_Overlay: 'extra-0-3-overlay',
  GradientRightActive: 'gradient-right-active',
  GradientRightHover: 'gradient-right-hover',
  Extra_0_5_Overlay: 'extra-0-5-overlay',
  Extra_0_7_Overlay: 'extra-0-7-overlay',
  Extra_0_9_Overlay: 'extra-0-9-overlay',
  Red_0_1_Overlay: 'red-0-1-overlay',
  Orange_0_1_Overlay: 'orange-0-1-overlay',
  Accent_0_8_Overlay: 'accent-0-8-overlay',
  Link: 'link',
  Camera: 'camera',
  GoogleDrive: 'google-drive',
  Dropbox: 'dropbox',
  OneDrive: 'one-drive',
  Device: 'device',
  Instagram: 'instagram',
  FreeImages: 'free-images',
  FreeIcons: 'free-icons',
  Canvas: 'canvas',
  Box: 'box',
  ScreenCast: 'screen-cast',
  Unsplash: 'unsplash',
  LightShadow: 'light-shadow',
  MediumShadow: 'medium-shadow',
  LargeShadow: 'large-shadow',
  XLargeShadow: 'x-large-shadow'
};